import { Inject, Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap } from 'rxjs/operators';
import { APP_CONFIG, AppConfig } from './app.models';
import { AuthService } from './auth.service';
import { checkPermissions } from './users/user.utils';
import { collectRoles, getLoggedInUserData } from './utils';

@Injectable()
export class AppGuard {
    constructor(private authService: AuthService, @Inject(APP_CONFIG) private appConfig: AppConfig) {}

    canActivate(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.check(route, state);
    }

    canLoad(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): boolean | Observable<boolean> {
        return this.check(route, state);
    }

    /**
     * async guard, because the auth process is async. Checks for authentication and permissions
     * @param route current route
     * @param state current routerState
     * @returns an observable of a boolean whether the user is authenticated and has the right permissions
     */
    check(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> {
        return this.authService.isDoneLoading$.pipe(
            filter((isDone) => {
                return isDone;
            }),
            switchMap((_) => this.authService.isAuthenticated$),
            map((isAuthenticated) => {
                if (isAuthenticated) {
                    if (route.data?.neededPermissions) {
                        const rolesInUserObj = { ...{}, roles: collectRoles(getLoggedInUserData(), this.appConfig.oidc_clientId) };
                        return isAuthenticated && checkPermissions(rolesInUserObj, route.data?.neededPermissions);
                    } else {
                        return isAuthenticated;
                    }
                } else {
                    this.authService.login(state.url);
                    return false;
                }
            })
        );
    }
}
